import {
  useEffect, useState, useCallback, ReactText,
} from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import GridPermissoes2 from './components/GridPermissoes2';
import FormCadastro from './components/FormCadastro';
import { Permissao, Pesquisa, Aplicacao } from '../../@types/exports';
import { api, alerts, doRefreshToken } from '../../utils';
import { load, AlertReact } from '../../components';

const Texto = (textoToReplace: string): ReactText => {
  console.log(textoToReplace);
  const { t } = useTranslation();
  const textReturn = t(`permissoes.${textoToReplace}`);
  return textReturn;
};
const HtmlToast = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      {Texto(textoToReplace)}
    </div>
  );
};
const HtmlDeletPerfil = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      <h4><b>{Texto(textoToReplace)}</b></h4>
    </div>
  );
};
const HtmlBotao = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      {Texto(textoToReplace)}
    </div>
  );
};
const Permissoes = () => {
  // Verifica se é necessário realizar o refresh token
  doRefreshToken.getRefreshToken();
  const { t } = useTranslation();
  const [permissoes, setPermissoes] = useState<Permissao[]>([]);
  const [permissaosOriginal, setPermissaoOriginal] = useState<Permissao[]>(permissoes);
  const [aplicacoes, setAplicacao] = useState<Aplicacao[]>([]);
  const [editarItem, setEditarItem] = useState<Permissao | undefined>();
  const pesquisa = (data: Pesquisa): void => {
    const { filtro, quantidade } = data;

    if (filtro !== undefined) {
      const filtrado = permissoes
        .filter((u) => u.name.toLowerCase().includes(filtro.toLowerCase()));

      setPermissoes(filtro.length && filtrado.length ? filtrado : permissaosOriginal);
      return;
    }

    if (quantidade !== undefined) {
      const quanti = permissaosOriginal.filter((u, i) => (i < quantidade));

      setPermissoes(!quantidade ? permissaosOriginal : quanti);
    }
  };

  const buscarPermissoesEAplicacoes = useCallback(async () => {
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    try {
      load.show();
      const { data: { perfis } } = await api.getPermissaoAplicacao();
      setPermissoes(perfis);
      setPermissaoOriginal(perfis);

      const { data: { produtos } } = await api.getAplicacoes();
      setAplicacao(produtos);
      // console.log('aplicacao', produtos);

      load.hide();
    } catch (error) {
      alerts.exibirErrorCatch(error);
      load.hide();
    }
  }, []);

  useEffect(() => {
    buscarPermissoesEAplicacoes();
  }, [buscarPermissoesEAplicacoes]);

  const removerItem = (permissao: Permissao) => {
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    load.show();
    AlertReact.message({
      html: <HtmlDeletPerfil textoToReplace="deleterPerfil" />,
      showDenyButton: true,
      denyButtonText: <HtmlBotao textoToReplace="botoes.voltar" />,
    })
      .then((result) => {
        try {
          if (result.isConfirmed) {
            // api.removerUsuario(usuario.id);
            api.deletePermissao(permissao.name);
            const removido = permissaosOriginal.filter((item) => item.id !== permissao.id);
            setPermissoes(removido);
            toast.success(
              <div>
                {permissao.name}
                &nbsp;
                <HtmlToast textoToReplace="excluido" />
              </div>,
            );
          }
        } catch (error) {
          alerts.exibirErrorCatch(error);
        } finally {
          load.hide();
        }
      });
  };

  // const editarPermissoes = (permissao: Permissao) => {
  //   console.log(permissao);
  //   console.log(permissao);
  //   load.show();
  //   AlertReact.message({
  //     html: `Alterar Perfil ${permissao.name}?`,
  //     showDenyButton: true,
  //     denyButtonText: 'Não',
  //   })
  //     .then((result) => {
  //       try {
  //         if (result.isConfirmed) {
  //           // api.removerUsuario(usuario.id);
  //           // const removido = usuarios.filter((item) => item.id !== usuario.id);
  //           // setUsuarios(removido);
  //           alerts.exibirToastSuccess(`Irei alterar perfil ${permissao.name} ${permissao.id}`);
  //         }
  //       } catch (error) {
  //         alerts.exibirErrorCatch(error);
  //       } finally {
  //         load.hide();
  //       }
  //     });
  // };

  return (
    <Container fluid>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">{t('permissoes.perfil')}</h1>
      </div>

      <GridPermissoes2
        permissoes={permissoes}
        pesquisa={pesquisa}
        setEditarItem={setEditarItem}
        removerItem={removerItem}
      />

      <FormCadastro
        atualizarLista={buscarPermissoesEAplicacoes}
        itemParaEditar={editarItem}
        aplicacoes={aplicacoes}
      />

    </Container>
  );
};

export default Permissoes;
